/**
 * Wrappers des hooks WS avec intégration du modal context (spécifique formulaires)
 * Les hooks de base sont dans @workspace/api
 */
import {
    useInit as useInitBase,
    useQueryGetTarif as useQueryGetTarifBase,
    useMutationFill as useMutationFillBase,
    useMutationGetTarif as useMutationGetTarifBase,
    useMutationSaveDevis as useMutationSaveDevisBase,
    useMutationPay as useMutationPayBase,
    useMutationPayEmbedded as useMutationPayEmbeddedBase,
    useMutationBesoinAide as useMutationBesoinAideBase,
    useMutationLogConsent as useMutationLogConsentBase,
    type LogConsentPayload,
    type UseInitProps,
    type UseMutationResult,
    type UseQueryResult,
    type PayEmbeddedResponse,
} from '@workspace/api';
import { useModal } from '../context/modal-context';

export type { UseInitProps, LogConsentPayload };

export const useInit = ({ token, origin, key, expire }: UseInitProps): UseQueryResult<any> => {
    const { showError } = useModal();
    return useInitBase({ token, origin, key, expire }, { onError: showError });
};

export const useQueryGetTarif = (token: string, data: any, refetchOnMount = true): UseQueryResult<any> => {
    const { showError } = useModal();
    return useQueryGetTarifBase(token, data, refetchOnMount, { onError: showError });
};

export const useMutationFill = (token: string): UseMutationResult<any> => {
    const { showError } = useModal();
    return useMutationFillBase(token, { onError: showError });
};

export const useMutationGetTarif = (token: string): UseMutationResult<any> => {
    const { showError } = useModal();
    return useMutationGetTarifBase(token, { onError: showError });
};

export const useMutationSaveDevis = (token: string): UseMutationResult<any> => {
    const { showError } = useModal();
    return useMutationSaveDevisBase(token, { onError: showError });
};

export const useMutationPay = (token: string): UseMutationResult<any> => {
    const { showError } = useModal();
    return useMutationPayBase(token, { onError: showError });
};

export const useMutationPayEmbedded = (token: string): UseMutationResult<PayEmbeddedResponse> => {
    const { showError } = useModal();
    return useMutationPayEmbeddedBase(token, { onError: showError });
};

export const useMutationBesoinAide = (): UseMutationResult<any> => {
    const { showError } = useModal();
    return useMutationBesoinAideBase({ onError: showError });
};

export const useMutationLogConsent = (): UseMutationResult<unknown, Error, LogConsentPayload> => {
    const { showError } = useModal();
    return useMutationLogConsentBase({ onError: showError });
};